<template>
  <el-dialog
    title="导出券码"
    :visible.sync="dialogVisible"
    :width="'600px'"
    :before-close="handleClose"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <div>
      <div>
        <span>请输入需要导出的券码数量</span>
        <el-input
          v-model="count"
          placeholder="请输入大于0小于等于1000的整数"
          style="width: 300px; margin-left: 10px;"></el-input>
      </div>
    </div>
    <div class="btns-coantainer">
      <el-button type="warning" plain @click="onCancel">取消</el-button>
      <el-button :loading="submitLoading" type="warning" @click="submit"
      >确认</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
let reg = /^(?:[1-9][0-9]{0,2}|1000)$/
import mini from "@/api/mini";
const MiniModel = new mini();
import {formatDate} from '@/utils/tool.js'
export default {
  data() {
    return {
      dialogVisible: false,
      row: null,
      count:'',
      submitLoading: false,
    }
  },
  methods:{
    open(row) {
      this.row = row
      this.count = ''
      this.submitLoading = false
      this.dialogVisible = true
    },
    handleClose() {
      this.dialogVisible = false
      this.count = ''
      this.row = null
      this.submitLoading = false
    },
    async submit() {
      if(!reg.test(this.count)) {
        this.$message.error('请输入大于0小于等于1000的整数')
        return
      }
      try{
        this.submitLoading = true
        const rep = await MiniModel.jdCouponExportCheck({
          count: this.count,
          templateCode: this.row.templateCode,
        })
        console.log(rep,'rep====')
        if(rep.data.code !== 200) {
          this.$message.error(rep.data.message)
          throw new Error(rep.data.message)
        }
        const res = await MiniModel.jdCouponExport({
          count: this.count,
          templateCode: this.row.templateCode,
        })
        console.log(res,'res')
        if(res.status == 200) {
          const blob = new Blob([res.data], {
            type: "application/vnd.ms-excel",
          });
          let url = window.URL.createObjectURL(blob);
          console.log("url", url);
          var a = document.createElement("a");
          document.body.appendChild(a);
          a.href = window.URL.createObjectURL(blob);
          a.download = "京东券导出_" + formatDate(new Date()) + ".xls";
          a.click();
          window.URL.revokeObjectURL(url);
          this.submitLoading = false
          this.$emit('updateDy')
          this.dialogVisible = false
        }else{
          throw new Error(res.data.message)
        }
      }catch (err) {
        console.log(err, '导出券码失败err')
        this.submitLoading = false
      }


    },
    onCancel() {
      this.dialogVisible = false
    }
  },
}
</script>

<style scoped lang="less">
.btns-coantainer{
  display: flex;
  justify-content: flex-end;
  margin-top: 50px;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/miniProgram/couponJd/component/exportCoupon.vue